
// shared
import { shared, generalProps } from './shared';
    
// types
import { Props, Context } from './types';
    
// vue
import { defineComponent } from 'vue';
    
export default defineComponent({
    name: 'rb-bot-status',
    props: generalProps,
    setup(props, context: Context) {
        return {
            ...shared(props as Readonly<Props>, context),
        };
    },
});
